import React, { useState, useContext, createContext } from 'react'
import { prepareApiRequest, withResponseHandling } from './utils'
import PropTypes from 'prop-types'

const createCrmApiClient = ({ apiUrl, apiToken }) => {
  return {
    fetchSiteAreaOrganisations: async (businessArea) => {
      const { url, headers } = prepareApiRequest({
        apiUrl,
        apiToken,
        endpoint: `/api/v2/site/areas/${businessArea}/organisations`,
      })
      const res = await fetch(url, {
        headers
      })

      return withResponseHandling(res)
    }
  }
}

const CrmApiContext = createContext({})

const CrmApiContextProvider = ({ client: initialClient, children }) => {
  const [client, setClient] = useState(initialClient)
  return (
    <CrmApiContext.Provider value={{ client, setClient }}>
      {children}
    </CrmApiContext.Provider>
  )
}

CrmApiContextProvider.propTypes = {
  client: PropTypes.object,
  children: PropTypes.any
}

const useCrmApiClient = () => {
  const { client } = useContext(CrmApiContext)

  if (!client) {
    throw(`Missing Crm API client, did you forget to wrap your components in CrmApiContextProvider?`)
  }

  return client
}

export {
  CrmApiContext,
  CrmApiContextProvider,
  useCrmApiClient,
  createCrmApiClient,
}
